module.exports = __webpack_public_path__ + "img/yahoo_maktoob_logo.21b701a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/arabic/yahoo_maktoob_logo.png
// module id = ./assets/img/media/arabic/yahoo_maktoob_logo.png
// module chunks = 0 9 11 12